/* eslint-disable react/no-unused-prop-types */
// component is extended and props are used in the inherited class but eslint doesn't recognize it
import * as React from 'react';
import classnames from 'classnames';
import { isArray } from 'lodash';

import MentionCard from '../mention-card/MentionCard';

import { isValidAssetUrl } from 'utils/url';
import { getCloudinaryImageUrl } from 'utils/cloudinary';
import { DEFAULT_PLACEHOLDER_IMAGE } from 'utils/image';

import './mention-card-modal-asset.scss';

import type { ChannelTypes, MentionCardModalItem } from 'types';
import type { ConsentReducerConsentsMap } from 'redux-store/types/ConsentReducer.type';

type Props = {
  selectedItem: MentionCardModalItem,
  currentPosition: number,
  userChannelConsents: ConsentReducerConsentsMap
};

class MentionCardModalAsset extends React.PureComponent<Props> {
  getHighQualityAssetUrl(assetUrl: string): string {
    const urlParts = assetUrl.split('?');

    return isArray(urlParts)
      ? `${urlParts[0]}?size=l`
      : assetUrl;
  }

  getAssetUrl(): string {
    const { selectedItem } = this.props;
    let assetUrl = selectedItem.assetUrl || DEFAULT_PLACEHOLDER_IMAGE;

    if (selectedItem.type === 'cloudinary-image') {
      assetUrl = getCloudinaryImageUrl(
        { url: selectedItem.assetUrl },
        { width: 368, height: 460, preserveAspectRatio: true }
      );
    }

    // ensure main asset is higher-quality
    // TODO: can't do it for now due to embed API issue
    // assetUrl = this.getHighQualityAssetUrl(assetUrl);

    return assetUrl;
  }

  getImageWrapperClasses(): string {
    const assetUrl = this.getAssetUrl();

    return classnames({
      'mention-card-modal-asset__item-image-wrapper': true,
      'mention-card-modal-asset__item-image-wrapper--placeholder': !assetUrl || !isValidAssetUrl(assetUrl)
    });
  }

  renderAssetImage(imageClasses: string): React.ReactNode {
    const assetUrl = this.getAssetUrl();

    return (
      <div
        className={imageClasses}
        style={{ backgroundImage: `url(${assetUrl})` }}
      />
    );
  }

  renderModalTrigger(children?: React.ReactNode): React.ReactNode {
    const { selectedItem } = this.props;
    const assetUrl = this.getAssetUrl();
    const imageWrapperClasses = this.getImageWrapperClasses();

    return (
      <div className={imageWrapperClasses}>
        <a
          key={`mention-card-modal-asset__item-${assetUrl}`}
          href={selectedItem.url}
          className="mention-card-modal-asset__item-image-link"
          rel="noopener noreferrer"
          target="_blank"
        >
          {children}
        </a>
      </div>
    );
  }

  renderMentionCard(channel: ChannelTypes): React.ReactNode {
    const { selectedItem } = this.props;

    return (
      <div className="mention-card-modal-asset__content">
        <MentionCard
          post={selectedItem}
          maxRowCount={10}
          channel={channel}
          viewType="modal"
        />
      </div>
    );
  }
}

export default MentionCardModalAsset;
